// Sprint notification-center (spec D3) — the Tier A chime.
//
// Synthesized with WebAudio (two short sine notes) instead of shipping
// an audio asset: no binary in the repo, no fetch, no licensing, and
// the volume/length live in code where they can be reviewed. Browsers
// block audio before the first user gesture (spec pre-mortem #3) — we
// lazily create the AudioContext and swallow every failure: the
// persistent toast is the primary signal, sound is the enhancement.
//
// New (verified no equivalent exists — nothing in web/ plays audio).
// 04-11 — el reproductor (un solo AudioContext, la espera al permiso del navegador) es el de lib/sonido.ts, compartido
// con los avisos de Santi de la oficina.
import { tocarNotas, type Nota } from './sonido';

// Two-note "ding-dong": E6 then A6, ~0.32 s total, gentle envelope.
const DING_DONG: readonly Nota[] = [
  { frecuencia: 1318.5, inicio: 0, duracion: 0.2, volumen: 0.12, ataque: 0.015 },
  { frecuencia: 1760, inicio: 0.12, duracion: 0.2, volumen: 0.12, ataque: 0.015 },
];

export function playNotificationChime(): void {
  // Autoplay-blocked (no user gesture yet) → stays silent, by policy, not by bug. Never throws.
  // Sin compresor: el mismo nivel de siempre (04-11, lib/sonido.ts).
  void tocarNotas(DING_DONG, { comprimir: false });
}
